import { timeUtil } from '@cmg/common';

import type { ParticipationReportGridColDef } from '../../types';

export const pricingDateColDef: ParticipationReportGridColDef = {
  headerName: 'Pricing Date',
  field: 'offeringPricingDate',
  type: ['date'],
  filter: false, // TODO: Re-enable filter when we add MUI date filtering support to ag-grid SSRM
  // filter: 'agDateColumnFilter',
  // floatingFilter: true,
  width: 114,
  pinned: 'left',
  sort: 'desc',
  lockPinned: true,
  lockPosition: true,
  lockVisible: true,
  valueFormatter: ({ value }) => timeUtil.getDisplayValueForMonthDateYear(value),
};
